export default class BMobileNav
{
	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `a[href="#mobile-nav"]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();
				this.open();
			}
		});

		document.addEventListener("click", event => {
			const selector = `.mobile-nav.active .close`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();
				this.close();
			}
		});
	}

	static open()
	{
		document.querySelector(`.mobile-nav`).classList.add("active");
		document.querySelector(`.mobile-nav-overlay`).style.display = "block";
		document.querySelector(`.mobile-nav-overlay`).style.opacity = 1;
	}

	static close()
	{
		document.querySelector(`.mobile-nav`).classList.remove("active");
		document.querySelector(`.mobile-nav-overlay`).style.display = "none";
		document.querySelector(`.mobile-nav-overlay`).style.opacity = 0;
	}
}
